// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__23Am9","bigColWidth":"Table_bigColWidth__Ovvnj","biggerColWidth":"Table_biggerColWidth__pa0cO","row":"Table_row__kNvAT","col":"Table_col__1QW67"};